import { JSX } from "react";

export const CategoryItemSkeleton = (): JSX.Element => {
    return (
        <>
            {Array(4)
                .fill(0)
                .map((_, index) => (
                    <div className={"c-products-list__item "} key={index}>
                        <div className="c-products-list__item__header">
                            <span className="skeleton skeleton-title"></span>
                            <div className="c-products-list__item__header__icon">
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                ))}
        </>
    );
};
